import { Chip } from '@mui/material';
import { FIELD_STATUS_VALUES } from 'business/constants';
import type { LifeCycleStatus } from 'business/types';
import { useTranslation } from 'react-i18next';

type Props = {
    currentStatus: LifeCycleStatus | undefined;
};

const FieldStatusChip = ({ currentStatus }: Props) => {
    const { t } = useTranslation();

    if (
        currentStatus === FIELD_STATUS_VALUES.DEFAULT ||
        currentStatus === undefined
    ) {
        return <></>;
    }

    const newChip = currentStatus === FIELD_STATUS_VALUES.NEW;

    return (
        <Chip
            label={t(`dataCatalog.fieldStatusManagement.${currentStatus}`)}
            size="small"
            sx={{
                color: 'white',
                width: 'fit-content',
                backgroundColor: (theme) =>
                    newChip
                        ? theme.palette.warning.main
                        : theme.palette.mediumGrey,
            }}
        />
    );
};

export default FieldStatusChip;
